import { createContext } from 'react';

const instanceContext = createContext();

export default instanceContext;
